// client/src/shared/utils/retry.js
export async function withRetry(fn, {
  retries = 3,
  baseDelayMs = 400,
  retryOn = (err) => {
    // Retry on network-ish errors & 5xx
    const msg = String(err?.message || err || "");
    if (/timeout|network|fetch/i.test(msg)) return true;
    const code = err?.status || err?.response?.status;
    return code >= 500 && code < 600;
  },
} = {}) {
  let attempt = 0, lastErr;
  while (attempt <= retries) {
    try { return await fn(); } catch (e) {
      lastErr = e;
      if (attempt === retries || !retryOn(e)) throw e;
      const jitter = Math.random() * 150;
      const delay = baseDelayMs * Math.pow(2, attempt) + jitter;
      await new Promise((r) => setTimeout(r, delay));
      attempt++;
    }
  }
  throw lastErr;
}
